export default {
    imageDashboardTransaction: {
        action: 'Actie',
        transactionId: 'Transactie ID',
        variationCount: 'Variatie Telling',
        date: 'Datum',
        cost: 'Kosten',
        description: 'Beschrijving',
        selectedImage: 'Geselecteerde afbeelding',
        goTo: 'Go naar',
    },
};
